// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * # Properties Panel styles
 *
 * Docked right-sidebar panel that shows/edits the selected entity's properties.
 *
 * Colours come from the shared IDE theme tokens (\`--color-ide-*\`, defined in
 * ide.css and switched by the \`[data-theme]\` attribute), so the panel follows
 * the light/dark/auto browser theme like the rest of the IDE.
 */

.properties-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
  font-size: 12px;
  background: var(--color-ide-surface);
  color: var(--color-ide-text);
}

.properties-panel-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1 auto;
  padding: 16px;
  text-align: center;
  color: var(--color-ide-text-muted);
}

.properties-section {
  border-bottom: 1px solid var(--color-ide-border);
  padding: 8px 12px;
}

.properties-section-title {
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  font-size: 10px;
  color: var(--color-ide-text-muted);
  margin-bottom: 6px;
}

.properties-field {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 6px;
}

.properties-field:last-child {
  margin-bottom: 0;
}

.properties-field-label {
  flex: 0 0 auto;
  color: var(--color-ide-text-muted);
}

.properties-field-control {
  flex: 1 1 auto;
  min-width: 0;
}

.properties-input,
.properties-select {
  width: 100%;
  box-sizing: border-box;
  background: var(--color-ide-bg);
  color: var(--color-ide-text);
  border: 1px solid var(--color-ide-border);
  border-radius: 3px;
  padding: 3px 6px;
  font-size: 12px;
  font-family: inherit;
}

.properties-input:focus,
.properties-select:focus {
  outline: none;
  border-color: var(--color-ide-accent);
}

.properties-input:disabled,
.properties-select:disabled {
  opacity: 0.7;
}

.properties-input-error {
  border-color: var(--color-ide-error);
}

.properties-row {
  display: flex;
  gap: 8px;
}

.properties-row .properties-field {
  flex: 1 1 0;
}

.properties-footer {
  position: sticky;
  bottom: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 8px 12px;
  border-top: 1px solid var(--color-ide-border);
  background: var(--color-ide-surface);
}

.properties-footer-buttons {
  display: flex;
  gap: 8px;
}

.properties-btn {
  flex: 1 1 0;
  padding: 5px 10px;
  border-radius: 3px;
  border: 1px solid var(--color-ide-border);
  background: var(--color-ide-surface-2);
  color: var(--color-ide-text);
  cursor: pointer;
  font-size: 12px;
  font-family: inherit;
  transition: background-color 0.1s, border-color 0.1s, opacity 0.1s;
}

.properties-btn:hover:not(:disabled) {
  background: var(--color-ide-hover-overlay-strong);
  border-color: var(--color-ide-text-dim);
}

.properties-btn-primary {
  background: var(--color-ide-accent);
  border-color: var(--color-ide-accent);
  color: #fff;
}

.properties-btn-primary:hover:not(:disabled) {
  background: var(--color-ide-accent-hover);
  border-color: var(--color-ide-accent-hover);
}

.properties-btn:disabled {
  opacity: 0.5;
  cursor: default;
}

.properties-error {
  color: var(--color-ide-error);
  font-size: 11px;
}

.properties-readonly {
  color: var(--color-ide-text);
}

.properties-checkbox-field {
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--color-ide-text);
}

/* ------------------------------------------------------------------ */
/* Active-design summary (shown at the bottom of the panel when there  */
/* is no selection, so the panel isn't empty while a design is open).  */
/* ------------------------------------------------------------------ */

.properties-design-info {
  margin-top: auto;
  padding: 8px 12px;
  border-top: 1px solid var(--color-ide-border);
  background: var(--color-ide-surface);
}

.properties-design-info-title {
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  font-size: 10px;
  color: var(--color-ide-text-muted);
  margin-bottom: 6px;
}

.properties-design-info-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 4px;
}

.properties-design-info-row:last-child {
  margin-bottom: 0;
}

.properties-design-info-label {
  flex: 0 0 auto;
  color: var(--color-ide-text-muted);
}

.properties-design-info-value {
  flex: 1 1 auto;
  min-width: 0;
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--color-ide-text);
}
`, "",{"version":3,"sources":["webpack://./src/components/PropertiesPanel/propertiesPanel.css"],"names":[],"mappings":"AAAA;;;;;;;;EAQE;;AAEF;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,gDAAgD;EAChD,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,sBAAsB;EACtB,+BAA+B;EAC/B,4BAA4B;EAC5B,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;EACb,qCAAqC;AACvC;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,6CAA6C;EAC7C,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;EACzC,sCAAsC;EACtC,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,kEAAkE;AACpE;;AAEA;EACE,iDAAiD;EACjD,uCAAuC;AACzC;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,4BAA4B;AAC9B;;AAEA,uEAAuE;AACvE,wEAAwE;AACxE,wEAAwE;AACxE,uEAAuE;;AAEvE;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6CAA6C;EAC7C,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,4BAA4B;AAC9B","sourcesContent":["/*\n * # Properties Panel styles\n *\n * Docked right-sidebar panel that shows/edits the selected entity's properties.\n *\n * Colours come from the shared IDE theme tokens (`--color-ide-*`, defined in\n * ide.css and switched by the `[data-theme]` attribute), so the panel follows\n * the light/dark/auto browser theme like the rest of the IDE.\n */\n\n.properties-panel {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow-y: auto;\n  font-size: 12px;\n  background: var(--color-ide-surface);\n  color: var(--color-ide-text);\n}\n\n.properties-panel-empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1 1 auto;\n  padding: 16px;\n  text-align: center;\n  color: var(--color-ide-text-muted);\n}\n\n.properties-section {\n  border-bottom: 1px solid var(--color-ide-border);\n  padding: 8px 12px;\n}\n\n.properties-section-title {\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  font-size: 10px;\n  color: var(--color-ide-text-muted);\n  margin-bottom: 6px;\n}\n\n.properties-field {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 6px;\n}\n\n.properties-field:last-child {\n  margin-bottom: 0;\n}\n\n.properties-field-label {\n  flex: 0 0 auto;\n  color: var(--color-ide-text-muted);\n}\n\n.properties-field-control {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.properties-input,\n.properties-select {\n  width: 100%;\n  box-sizing: border-box;\n  background: var(--color-ide-bg);\n  color: var(--color-ide-text);\n  border: 1px solid var(--color-ide-border);\n  border-radius: 3px;\n  padding: 3px 6px;\n  font-size: 12px;\n  font-family: inherit;\n}\n\n.properties-input:focus,\n.properties-select:focus {\n  outline: none;\n  border-color: var(--color-ide-accent);\n}\n\n.properties-input:disabled,\n.properties-select:disabled {\n  opacity: 0.7;\n}\n\n.properties-input-error {\n  border-color: var(--color-ide-error);\n}\n\n.properties-row {\n  display: flex;\n  gap: 8px;\n}\n\n.properties-row .properties-field {\n  flex: 1 1 0;\n}\n\n.properties-footer {\n  position: sticky;\n  bottom: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 8px 12px;\n  border-top: 1px solid var(--color-ide-border);\n  background: var(--color-ide-surface);\n}\n\n.properties-footer-buttons {\n  display: flex;\n  gap: 8px;\n}\n\n.properties-btn {\n  flex: 1 1 0;\n  padding: 5px 10px;\n  border-radius: 3px;\n  border: 1px solid var(--color-ide-border);\n  background: var(--color-ide-surface-2);\n  color: var(--color-ide-text);\n  cursor: pointer;\n  font-size: 12px;\n  font-family: inherit;\n  transition: background-color 0.1s, border-color 0.1s, opacity 0.1s;\n}\n\n.properties-btn:hover:not(:disabled) {\n  background: var(--color-ide-hover-overlay-strong);\n  border-color: var(--color-ide-text-dim);\n}\n\n.properties-btn-primary {\n  background: var(--color-ide-accent);\n  border-color: var(--color-ide-accent);\n  color: #fff;\n}\n\n.properties-btn-primary:hover:not(:disabled) {\n  background: var(--color-ide-accent-hover);\n  border-color: var(--color-ide-accent-hover);\n}\n\n.properties-btn:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n\n.properties-error {\n  color: var(--color-ide-error);\n  font-size: 11px;\n}\n\n.properties-readonly {\n  color: var(--color-ide-text);\n}\n\n.properties-checkbox-field {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: var(--color-ide-text);\n}\n\n/* ------------------------------------------------------------------ */\n/* Active-design summary (shown at the bottom of the panel when there  */\n/* is no selection, so the panel isn't empty while a design is open).  */\n/* ------------------------------------------------------------------ */\n\n.properties-design-info {\n  margin-top: auto;\n  padding: 8px 12px;\n  border-top: 1px solid var(--color-ide-border);\n  background: var(--color-ide-surface);\n}\n\n.properties-design-info-title {\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  font-size: 10px;\n  color: var(--color-ide-text-muted);\n  margin-bottom: 6px;\n}\n\n.properties-design-info-row {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 4px;\n}\n\n.properties-design-info-row:last-child {\n  margin-bottom: 0;\n}\n\n.properties-design-info-label {\n  flex: 0 0 auto;\n  color: var(--color-ide-text-muted);\n}\n\n.properties-design-info-value {\n  flex: 1 1 auto;\n  min-width: 0;\n  text-align: right;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: var(--color-ide-text);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
